import React, { useState, useEffect, useCallback } from 'react';
import api from '../config/api';

const HistoricoPagamento = () => {
    const [pagamentos, setPagamentos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const carregarHistorico = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const usuarioId = localStorage.getItem('usuarioId') || 1;
            const response = await api.get(`/pagamento/usuario/${usuarioId}`);
            
            console.log('Resposta do servidor:', response.data);

            if (Array.isArray(response.data)) {
                setPagamentos(response.data);
            } else {
                setPagamentos([]);
            }
        } catch (err) {
            console.error('Erro ao carregar histórico:', err.response?.data || err.message);
            
            // Verificar se é erro de autenticação
            if (err.response?.status === 401 || err.response?.status === 403) {
                setError('⚠️ Você precisa estar autenticado para ver o histórico');
            } else {
                setError('Erro ao carregar histórico de pagamentos');
            }
            setPagamentos([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        carregarHistorico();
    }, [carregarHistorico]);

    const formatarData = (dataString) => {
        const data = new Date(dataString);
        return data.toLocaleDateString('pt-BR');
    };

    const formatarHora = (dataString) => {
        const data = new Date(dataString);
        return data.toLocaleTimeString('pt-BR');
    };

    const getStatusClass = (status) => {
        const statusLower = status.toLowerCase();
        if (statusLower.includes('aprovado') || statusLower.includes('approved')) {
            return 'status-approved';
        } else if (statusLower.includes('pendente') || statusLower.includes('pending')) {
            return 'status-pending';
        } else {
            return 'status-rejected';
        }
    };

    const getTipoPagamentoIcon = (tipo) => {
        return tipo === 'PIX' ? '📱 PIX' : '💳 Cartão';
    };

    if (loading) {
        return (
            <div className="tab-content active">
                <div className="payment-history">
                    <h3>Seus Pagamentos</h3>
                    <p style={{ color: '#999' }}>Carregando histórico...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="tab-content active">
                <div className="payment-history">
                    <h3>Seus Pagamentos</h3>
                    <p style={{ color: 'red' }}>{error}</p>
                    <button 
                        onClick={carregarHistorico}
                        className="btn-submit"
                        style={{ marginTop: '20px' }}
                    >
                        Tentar Novamente
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="tab-content active">
            <div className="payment-history">
                <h3>Seus Pagamentos</h3>
                
                {pagamentos.length === 0 ? (
                    <p style={{ color: '#999' }}>Nenhum pagamento realizado ainda</p>
                ) : (
                    <div className="payments-list">
                        {pagamentos.map((pagamento, index) => (
                            <div key={index} className="payment-item">
                                <div className="payment-item-info">
                                    <div className="payment-type">
                                        {getTipoPagamentoIcon(pagamento.tipoPagamento)}
                                    </div>
                                    <div className="payment-item-date">
                                        {formatarData(pagamento.dataPagamento)} às{' '}
                                        {formatarHora(pagamento.dataPagamento)}
                                    </div>
                                    {pagamento.descricao && (
                                        <div className="payment-description">
                                            {pagamento.descricao}
                                        </div>
                                    )}
                                </div>
                                <div className="payment-item-amount">
                                    R$ {pagamento.valor.toFixed(2)}
                                </div>
                                <div className={`payment-item-status ${getStatusClass(pagamento.status)}`}>
                                    {pagamento.status}
                                    {pagamento.statusMP && (
                                        <div style={{ fontSize: '11px', marginTop: '4px', opacity: 0.8 }}>
                                            MP: {pagamento.statusMP}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <button 
                    onClick={carregarHistorico}
                    className="btn-submit"
                    style={{ marginTop: '20px' }}
                >
                    🔄 Atualizar Histórico
                </button>
            </div>
        </div>
    );
};

export default HistoricoPagamento;
